import React from 'react'
import Loader from 'containers/loader/loader'
import './claim.css'

/**
 * Full-page holding state for the one-click /claim/* email routes: they do
 * their work on mount and immediately redirect, so all a visitor ever sees
 * is this brief branded loading screen.
 */
const ClaimLanding: React.FC<{ message: string }> = ({ message }) => (
  <div className='claim-landing'>
    <div className='claim-landing-inner'>
      <Loader showText={false} color='#068466' />
      <p className='claim-landing-message'>{message}</p>
    </div>
  </div>
)

export default ClaimLanding
